import {
  deleteTask,
  DeleteTaskData,
  endTask,
  EndTaskData,
  getTaskList,
  GetTaskListData,
  getTaskReport,
  GetTaskReport,
} from '@/api/fishing-task'
import { Message } from '@/components/message'
import { useRequest } from 'ahooks'
import { message } from 'antd'
import { t } from '@/i18n'
interface UseGetTaskListProps {
  getTaskListData: GetTaskListData
}

export const useGetTaskList = (props: UseGetTaskListProps) => {
  const { getTaskListData } = props

  const { data, loading, run } = useRequest(() => getTaskList(getTaskListData), {
    refreshDeps: [getTaskListData],
    loadingDelay: 1000,
    onError(err: any) {
      Message.error(err?.msg || t('列表加载失败'))
    },
  })

  return [data?.data || { tasks: [], total: 0 }, loading, run] as const
}

export const useEndTask = () => {
  const { runAsync, loading } = useRequest((data: EndTaskData) => endTask(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('任务结束失败'))
    },
  })
  return [runAsync, loading] as const
}

export const useDeleteTask = () => {
  const { runAsync, loading } = useRequest((data: DeleteTaskData) => deleteTask(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('任务删除失败'))
    },
  })
  return [runAsync, loading] as const
}

// 生成报表
export const useGetTaskReport = () => {
  const { runAsync, loading } = useRequest((data: GetTaskReport) => getTaskReport(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('生成报表失败'))
    },
  })

  return [runAsync, loading] as const
}
